<div class="bm--auth-form-box">
  <h1 class="common-section-title common-section-title--form">Sign in</h1>
  <div class="login-page__form-box">
    <bmcore-login-form></bmcore-login-form>
  </div>
  <div class="login-page__hint-box">
    <p class="bm--auth-form__hint bm--auth-form__hint--text">Don’t have an account?</p>
    <a class="bm--auth-form__hint bm--auth-form__hint--link" routerLink="/sign-up">Sign Up</a>
  </div>
</div>
